import { Link } from "react-router-dom";

/**
 * Links a username/avatar to that user's public profile (/u/:username).
 * Falls back to plain text (children or name) when no username is available.
 * Stops click propagation so it works inside clickable cards.
 */
export default function UserLink({ username, children, className = "", prefix = false, testid }) {
    if (!username) return <span className={className}>{children ?? "user"}</span>;
    return (
        <Link
            to={`/u/${username}`}
            data-testid={testid}
            title={username}
            onClick={(e) => e.stopPropagation()}
            className={`hover:text-[#ff4500] hover:underline transition-colors ${className}`}
        >
            {children ?? `${prefix ? "@" : ""}${username}`}
        </Link>
    );
}
